import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { EmployeesServiceProvider } from '../../api/employees'

const EmployeesService = EmployeesServiceProvider()
const name = 'updateEmployee'

export default (data) => (asyncAction(
  name,
  EmployeesService.updateEmployee,
  data
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/employee/updateEmployee.js